import React, { FC } from 'react'

interface TranslatableTextProps {
  originalText: string
  translationMap?: Map<string, string>
}

/* There are three components to translate user generated content (UGC):
 *  - TranslateWrapper
 *  - TranslatableText
 *  - TranslateButton
 *
 * These components are meant for translating an arbitrary number of strings (potentially with
 * other components between them) with a single button. If you only need to translate a single
 * string with each button, and the button can go directly underneath the string, use component
 * TranslatableContent instead.
 *
 * HOW TO USE:
 *
 * Before:
 *
 * <div>
 *  {stringToTranslate1}
 *  ...
 *  {stringToTranslateN}
 * </div>
 *
 * After:
 *
 * <div>
 *  <TranslateWrapper sourceLang={'fi'}>
 *    <TranslatableText originalText={stringToTranslate1} />
 *    ...
 *    <TranslatableText originalText={stringToTranslateN} />
 *    <TranslateButton />
 *  <TranslateWrapper />
 * </div>
 *
 */

const TranslatableText: FC<TranslatableTextProps> = (props): JSX.Element => {
  const { originalText, translationMap } = props

  if (!translationMap || !translationMap.has(originalText)) {
    return <>{originalText}</>
  }

  const text = translationMap.get(originalText)

  return <>{text}</>
}

export default TranslatableText
